<div class="sir-card-flip__inner">
    <button
        #flipToggle
        type="button"
        class="sir-card-flip__toggle"
        [id]="flipToggleId"
        [attr.aria-expanded]="isFlipped()"
        [attr.aria-controls]="backFaceId"
        [attr.aria-label]="flipToggleLabel()"
        (click)="toggleFlip($event, true); $event.stopPropagation()">
    </button>

    <div
        class="sir-card-flip__face sir-card-flip__face--front"
        [attr.aria-hidden]="isFlipped() ? 'true' : null"
        [attr.inert]="isFlipped() ? '' : null">
        @if (hasImage()) {
            <div class="sir-card-flip__media">
                <sirius-image-item
                    [image]="resolvedImage()"
                    [alt]="imageAlt()"
                    [autocrop]="true"
                    [imageData]="imageData()"
                    objectFit="cover"></sirius-image-item>
            </div>
        }
        <span class="sir-card-flip__hint" aria-hidden="true">
            <sirius-icon name="repeat"></sirius-icon>
        </span>
        <div class="sir-card-flip__caption" aria-hidden="true">
            <p class="sir-card-flip__caption-text sir-text-style-paragraph-l-bold">{{ resolvedCaptionHtml() }}</p>
        </div>
    </div>

    <div
        class="sir-card-flip__face sir-card-flip__face--back sir-text-context-on-dark has-footer"
        [id]="backFaceId"
        role="region"
        [attr.aria-label]="backFaceLabel()"
        [attr.aria-hidden]="!isFlipped() ? 'true' : null"
        [attr.inert]="!isFlipped() ? '' : null">
        <span class="sir-card-flip__hint" aria-hidden="true">
            <sirius-icon name="repeat"></sirius-icon>
        </span>
        <div class="sir-card-flip__back-stage">
            <div class="sir-card-flip__back-body">
                <div class="sir-card-flip__back-text">
                    <sirius-text-html [html]="resolvedBackHtml()" textStyleSize="l"></sirius-text-html>
                </div>
            </div>
        </div>

        @if (showCta()) {
            <div class="sir-card-flip__footer sir-card-flip__footer--link">
                <a
                    #backCtaLink
                    [siriusLink]="resolvedLink()"
                    class="sir-card-flip__link sir-text-style-paragraph-m-bold"
                    (linkSelect)="onLinkClick()">
                    {{ resolvedLink().title
                    }}<sirius-icon [name]="'arrow_right_small'" aria-hidden="true"></sirius-icon>
                </a>
            </div>
        } @else {
            <div class="sir-card-flip__footer">
                <p class="sir-card-flip__caption-text sir-text-style-paragraph-l-bold">{{ resolvedCaptionHtml() }}</p>
            </div>
        }
    </div>
</div>
